export const searchReportOrdersTemplate = [
  { header: 'searchReportOrders.dataResult.pedido_item' },
  { header: 'searchReportOrders.dataResult.material_mes' },
  { header: 'searchReportOrders.dataResult.descricao_mes' },
  { header: 'searchReportOrders.dataResult.ordem_de_processo' },
  { header: 'searchReportOrders.dataResult.corrida' },
  { header: 'searchReportOrders.dataResult.sample_batch' },
  { header: 'searchReportOrders.dataResult.numero_da_peca' },
  { header: 'searchReportOrders.dataResult.posicao' },
  { header: 'searchReportOrders.dataResult.ensaio_mes' },
  { header: 'searchReportOrders.dataResult.id_numeric' },
  { header: 'searchReportOrders.dataResult.id_hex' },
  { header: 'searchReportOrders.dataResult.status' },
  { header: 'searchReportOrders.dataResult.login_date' },
  { header: 'searchReportOrders.dataResult.document_name' },
]
